import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GeneralSettingsComponent } from "./general-settings.component";
import { AuthGuard } from "@app/auth/auth.guard";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "@app/material/material.module";
import { FuseSharedModule } from "@fuse/shared.module";
import { MaterialFileInputModule } from "ngx-material-file-input";
import { NgxPaginationModule } from "ngx-pagination";
import { GeneralSettingsService } from "@app/main/content/general-settings/general-settings.service";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { SortablejsModule } from "angular-sortablejs";
import { ThresholdRewardComponent } from "./threshold-reward/threshold-reward.component";
import { ThresholdRewardFormComponent } from "./threshold-reward/threshold-reward-form/threshold-reward-form.component";
import { GameCategoriesComponent } from "./game-categories/game-categories.component";
import { DefaultEmojisComponent } from "./default-emojis/default-emojis.component";
import { CategoryFormComponent } from "@app/main/content/general-settings/game-categories/category-form/category-form.component";
import { FormsModule } from "@angular/forms";
import { DontationCategoriesComponent } from "./dontation-categories/dontation-categories.component";
import { DonationCategoryFormComponent } from "./dontation-categories/donation-category-form/donation-category-form.component";
import { OrganizationsDialogComponent } from "./dontation-categories/organizations-dialog/organizations-dialog.component";
import { MatRippleModule } from "@angular/material";
import { ExpansionElementComponent } from "./expansion-element/expansion-element.component";
import { AcceptedLinksComponent } from './accepted-links/accepted-links.component';
import { SplashScreenTitleRowComponent } from "./splash-screen-title-row/splash-screen-title-row.component";

const routes = [
  {
    path: "settings",
    component: GeneralSettingsComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: GeneralSettingsService,
    },
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    MaterialModule,
    FuseSharedModule,
    MaterialFileInputModule,
    NgxPaginationModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SortablejsModule,

    MatRippleModule,
  ],
  declarations: [
    GeneralSettingsComponent,
    CategoryFormComponent,
    ThresholdRewardComponent,
    ThresholdRewardFormComponent,
    GameCategoriesComponent,
    DefaultEmojisComponent,
    DontationCategoriesComponent,
    DonationCategoryFormComponent,
    OrganizationsDialogComponent,
    ExpansionElementComponent,
    AcceptedLinksComponent,
    SplashScreenTitleRowComponent,
  ],
  entryComponents: [
    CategoryFormComponent,
    ThresholdRewardFormComponent,
    DonationCategoryFormComponent,
    OrganizationsDialogComponent,
    ExpansionElementComponent,
    SplashScreenTitleRowComponent,
  ],
  providers: [GeneralSettingsService],
})
export class GeneralSettingsModule { }
